import CloseButton from './CloseButton.js';

import {
  notificationContainerStyles,
  notificationIconContainerStyle,
  notificationImgContainerStyles,
  notificationImgStyles,
  notificationsHeadlineStyle,
  notificationSubtextStyle,
  notificationTextContainerStyle
} from '@/components/Toast/components/styles';
import { INotification } from '@/components/Toast/components/types/notification.interface.ts';
import { Image } from '@/components/common/Image/Image.tsx';
import FireReactionShape from '@/components/common/svg/shapes/FireReactionShape.tsx';
import UIConfig from '@/UIConfig.ts';

const GiftNotification = ({
  onClose,
  onClick,
  contact,
  msg,
  style
}: INotification) => {
  const handleClick = () => {
    onClick && onClick();
    onClose();
  };

  return (
    <div onClick={handleClick} style={notificationContainerStyles}>
      <div style={notificationImgContainerStyles}>
        <Image
          style={{ ...notificationImgStyles, ...style }}
          src={contact?.photo_url}
          alt="Like Notification"
        />
        <FireReactionShape
          width={16}
          height={16}
          fillColor="#ffffff"
          style={{
            position: 'absolute',
            bottom: '-4px',
            right: '-4px',
            background: UIConfig.Colors.PrimaryGradient,
            borderRadius: '50%',
            padding: '4px'
          }}
        />
      </div>
      <div style={notificationTextContainerStyle}>
        <div style={notificationsHeadlineStyle}>{contact?.name}</div>
        <p style={notificationSubtextStyle}>{msg}</p>
      </div>
      <div style={notificationIconContainerStyle}>
        <CloseButton handleClose={onClose} />
      </div>
    </div>
  );
};

export default GiftNotification;
